import React from "react";
import { Heading } from "@chakra-ui/react";

export const Title = ({ title }: { title: string }) => (
  <Heading as="h2" variant="h2" my="1em" textAlign="center">
    {title}
  </Heading>
);
